import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from "../components/Navbar";
import HeroBanner from "../components/HeroBanner";

const Test = () => {
    const navigate = useNavigate();

    const handleBack = (e) => {
        e.preventDefault();
        navigate(-1); // go back to previous page
    };

    return (
        <>
        <Navbar />
            <HeroBanner
                heroTitle="Simulation integration example"
                heroDescription="This page shows the potential of embedding a simulation platform"
                imageUrl="/images/digiTwins.png"
                height="165px"
            />
        <Box sx={{ width: '100%', height: '600px' }}>
  <iframe
    src="https://biomodels.bacpop.org/view/BIOMD0000000573?time=5&ymax=100"
    style={{ width: '100%', height: '100%', border: 0 }}
    title="BIOMD0000000573"
  />
</Box>
</>
    );
};

export default Test;

